import { Chip } from '@mui/material';
import React from 'react';

export function CustomChip({ children, ...props }: any) {
    return (
        <Chip
            {...props}
            sx={{
                minWidth: '120px',
                height: 'auto',
                cursor: props.cursor,
                ...props.sx,
            }}
            label={props.label}
        />
    );
}

export function CustomSmallListChip({ children, ...props }: any) {
    return (
        <Chip
            {...props}
            sx={{
                width: 'auto',
                height: 'auto',
                justifyContent: 'center',
                fontSize: '10px',
                borderRadius: 1,
                ...props.sx,
            }}
            label={props.label}
        />
    );
}
